import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ensureConfig } from "./config";
import { applyOceanEnvOverrides } from "./services/waveClientConfig";
import { initWaveTheme } from "./services/waveTheme";
import "./index.css";

initWaveTheme();

const strictMode =
  import.meta.env.PROD || import.meta.env.VITE_STRICT_MODE !== "false";

void ensureConfig()
  .then(() => {
    applyOceanEnvOverrides();
    const tree = strictMode ? (
      <StrictMode>
        <App />
      </StrictMode>
    ) : (
      <App />
    );
    createRoot(document.getElementById("root")!).render(tree);
  })
  .catch((e) => {
    document.body.innerHTML = `<pre style="padding:2rem;color:#b91c1c">${e instanceof Error ? e.message : String(e)}</pre>`;
  });
